export function sortByName(a, b) {
    return a.name.localeCompare(b.name);
}
